{
  "DownloadReportDialog": {
    "title": "Pobierz raport",
    "fieldScope": "Przestrzeń robocza",
    "selectScope": "Wybierz przestrzeń roboczą",
    "wholeOrganization": "Wszystkie przestrzenie robocze — cała organizacja",
    "download": "Pobierz",
    "downloadFailed": "Nie udało się pobrać raportu. Spróbuj ponownie."
  },
  "entityTypes": {
    "contact": "Zasoby",
    "callout": "Callouty",
    "shortlist": "Shortlisty",
    "callsheet": "Callsheety",
    "production": "Produkcje",
    "booking": "Rezerwacje"
  },
  "ReportTemplateColumns": {
    "name": "Nazwa",
    "description": "Opis",
    "type": "Typ"
  },
  "ReportTemplatesPage": {
    "title": "Szablony raportów",
    "newTemplate": "Nowy szablon raportu",
    "entityNameSingular": "szablon raportu",
    "rowActions": "Akcje szablonu",
    "editTemplate": "Edytuj szablon",
    "viewTemplate": "Pokaż szablon",
    "downloadReport": "Pobierz raport",
    "downloadReportInDialog": "Pobierz raport…",
    "archiveTemplate": "Archiwizuj szablon",
    "unarchiveTemplate": "Przywróć szablon",
    "archiveSuccess": "Szablon raportu został zarchiwizowany",
    "unarchiveSuccess": "Szablon raportu został przywrócony",
    "emptyActive": "Brak szablonów raportów",
    "emptyArchived": "Brak zarchiwizowanych szablonów raportów",
    "emptyMessage": "Eksport danych pozwala pobrać dane jako plik CSV"
  },
  "WorkspaceReportingPage": {
    "title": "Raporty",
    "downloadReport": "Pobierz raport",
    "settingsLabel": "Konfiguruj szablony raportów",
    "settingsInOrganization": "W tej organizacji",
    "workspaceFailed": "Nie udało się wczytać tej przestrzeni roboczej, więc nie można pobrać jej raportów."
  },
  "ReportTemplateEditor": {
    "titleCreate": "Nowy szablon raportu",
    "titleEdit": "Edytuj szablon raportu",
    "titleView": "Szablon raportu",
    "create": "Utwórz szablon",
    "save": "Zapisz zmiany",
    "close": "Zamknij",
    "name": "Nazwa",
    "namePlaceholder": "np. Tygodniowa lista talentów",
    "nameRequired": "Podaj nazwę",
    "description": "Opis",
    "descriptionPlaceholder": "Do czego służy raport",
    "reportOn": "Raport dotyczy",
    "typeLabel": {
      "contact": "Typ zasobu",
      "booking": "Typ rezerwacji",
      "production": "Typ produkcji"
    },
    "typeAll": {
      "contact": "Wszystkie typy zasobów",
      "booking": "Wszystkie typy rezerwacji",
      "production": "Wszystkie typy produkcji"
    },
    "archivedType": "{{name}} (zarchiwizowany)",
    "filters": "Filtry",
    "filtersHint": "Które rekordy obejmuje raport. Do tego dochodzi przestrzeń robocza, w której jest pobierany.",
    "dateFields": {
      "created_at": "Utworzono",
      "booking_date": "Data rezerwacji",
      "production_date": "Data produkcji",
      "callsheet_date": "Data callsheetu"
    },
    "dateGroup": "Daty",
    "booked": "Zarezerwowany",
    "columns": "Kolumny",
    "columnsHint": "Kolumny pliku, w tej kolejności.",
    "columnsRequired": "Wybierz co najmniej jedną kolumnę",
    "idColumn": "ID",
    "guidColumn": "GUID",
    "relativeDates": {
      "TODAY": "Dziś",
      "YESTERDAY": "Wczoraj",
      "TOMORROW": "Jutro",
      "LAST_7": "Ostatnie 7 dni",
      "LAST_30": "Ostatnie 30 dni",
      "NEXT_7": "Następne 7 dni",
      "NEXT_30": "Następne 30 dni",
      "LAST_WEEK": "Poprzedni tydzień",
      "NEXT_WEEK": "Następny tydzień",
      "LAST_MONTH": "Poprzedni miesiąc",
      "NEXT_MONTH": "Następny miesiąc",
      "QUARTER": "Bieżący kwartał",
      "LAST_QUARTER": "Poprzedni kwartał",
      "NEXT_QUARTER": "Następny kwartał"
    }
  },
  "ReportFile": {
    "ready": "Raport jest gotowy.",
    "open": "Otwórz raport"
  }
}
